import { AxiosResponseHeaders } from 'axios';
import { InitiateTransferResponseDTO } from '../entities';

const initiateTransferDTOToInitiateTransferAdapter = (
  data: InitiateTransferResponseDTO,
  headers?: AxiosResponseHeaders,
) => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { initiateTransferDTOToInitiateTransferAdapter };
